/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Countryselector_Nocountries2Inputs */

const id_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada negara ditemukan`)
};

const ms_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada negara ditemui`)
};

const da_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen lande fundet`)
};

const de_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Länder gefunden`)
};

const en_us2_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No countries found`)
};

const es_es2_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron países`)
};

const es_mx2_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron países`)
};

const fil_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang bansa`)
};

const fr_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun pays trouvé`)
};

const it_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun paese trovato`)
};

const hu_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található ország`)
};

const nl_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen landen gevonden`)
};

const no_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen land funnet`)
};

const pl_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono krajów`)
};

const pt_br2_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No countries found`)
};

const pt_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum país encontrado`)
};

const ro_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit țări`)
};

const fi_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maita ei löytynyt`)
};

const sv_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga länder hittades`)
};

const vi_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy quốc gia`)
};

const tr_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülke bulunamadı`)
};

const cs_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné země`)
};

const bg_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени държави`)
};

const ru_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страны не найдены`)
};

const uk_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Країн не знайдено`)
};

const ar_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على دول`)
};

const hi_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई देश नहीं मिला`)
};

const th_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบประเทศ`)
};

const ja_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国が見つかりません`)
};

const zh_cn2_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No countries found`)
};

const zh_hant1_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No countries found`)
};

const ko_components_countryselector_nocountries2 = /** @type {(inputs: Components_Countryselector_Nocountries2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No countries found`)
};

/**
* | output |
* | --- |
* | "No countries found" |
*
* @param {Components_Countryselector_Nocountries2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_countryselector_nocountries2 = /** @type {((inputs?: Components_Countryselector_Nocountries2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Countryselector_Nocountries2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_countryselector_nocountries2(inputs)
	if (locale === "ms") return ms_components_countryselector_nocountries2(inputs)
	if (locale === "da") return da_components_countryselector_nocountries2(inputs)
	if (locale === "de") return de_components_countryselector_nocountries2(inputs)
	if (locale === "en-US") return en_us2_components_countryselector_nocountries2(inputs)
	if (locale === "es-ES") return es_es2_components_countryselector_nocountries2(inputs)
	if (locale === "es-MX") return es_mx2_components_countryselector_nocountries2(inputs)
	if (locale === "fil") return fil_components_countryselector_nocountries2(inputs)
	if (locale === "fr") return fr_components_countryselector_nocountries2(inputs)
	if (locale === "it") return it_components_countryselector_nocountries2(inputs)
	if (locale === "hu") return hu_components_countryselector_nocountries2(inputs)
	if (locale === "nl") return nl_components_countryselector_nocountries2(inputs)
	if (locale === "no") return no_components_countryselector_nocountries2(inputs)
	if (locale === "pl") return pl_components_countryselector_nocountries2(inputs)
	if (locale === "pt-BR") return pt_br2_components_countryselector_nocountries2(inputs)
	if (locale === "pt") return pt_components_countryselector_nocountries2(inputs)
	if (locale === "ro") return ro_components_countryselector_nocountries2(inputs)
	if (locale === "fi") return fi_components_countryselector_nocountries2(inputs)
	if (locale === "sv") return sv_components_countryselector_nocountries2(inputs)
	if (locale === "vi") return vi_components_countryselector_nocountries2(inputs)
	if (locale === "tr") return tr_components_countryselector_nocountries2(inputs)
	if (locale === "cs") return cs_components_countryselector_nocountries2(inputs)
	if (locale === "bg") return bg_components_countryselector_nocountries2(inputs)
	if (locale === "ru") return ru_components_countryselector_nocountries2(inputs)
	if (locale === "uk") return uk_components_countryselector_nocountries2(inputs)
	if (locale === "ar") return ar_components_countryselector_nocountries2(inputs)
	if (locale === "hi") return hi_components_countryselector_nocountries2(inputs)
	if (locale === "th") return th_components_countryselector_nocountries2(inputs)
	if (locale === "ja") return ja_components_countryselector_nocountries2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_countryselector_nocountries2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_countryselector_nocountries2(inputs)
	return ko_components_countryselector_nocountries2(inputs)
});
export { components_countryselector_nocountries2 as "components.countrySelector.noCountries" }